import React from 'react';
import type { Autocomplete } from '@mui/lab';
import { TypeAheadAutoComplete } from '../components/inputs/autocomplete/TypeAheadAutoComplete';
import type { InputLabelBaseProps } from '../components/inputs/InputLabelBase';
import type { IndustryValue } from './LanguageIndustryAutoComplete';
import { useIndustryCodeSearch } from './useIndustryCodeSearch';

export interface NaicsIndustryAutoCompleteProps {
  label: string;
  name: string;
  required?: boolean;
  onSelect: (value: IndustryValue) => void;
  autoCompleteProps?: React.ComponentType<typeof Autocomplete> | object;
  inputLabelBaseProps?: Omit<InputLabelBaseProps, 'children'>;
}

// Helper function to transform industry data to option format
const transformIndustryToOption = (industry: any) => {
  return {
    label: `${industry?.naicsCode} ${
      industry.secondaryIndustry && `[${industry.secondaryIndustry}]`
    }`,
    value: industry?.naicsCode,
    meta: {
      primaryIndustry: industry.primaryIndustry,
      secondaryIndustry: industry.secondaryIndustry,
      naicsCode: industry?.naicsCode,
      industryClass: industry.industryClass,
    },
  } satisfies IndustryValue;
};

const mapToIndustryOptions = (content: any[]) =>
  content.map(transformIndustryToOption);

export const NaicsIndustryAutoComplete = (
  props: NaicsIndustryAutoCompleteProps
) => {
  const getIndustryCodes = useIndustryCodeSearch(mapToIndustryOptions);

  return <TypeAheadAutoComplete asyncFunction={getIndustryCodes} {...props} />;
};
